import { z } from 'zod';
export const notificationTypesSchema = z.object({
    // org maintainer notifications
    'org_maintainer:project_created:email': z.boolean(),
    'org_maintainer:project_created:in_app': z.boolean(),
    'org_maintainer:member_added:email': z.boolean(),
    'org_maintainer:member_added:in_app': z.boolean(),
    // project owner notifications
    'project_owner:member_added_as_owner:email': z.boolean(),
    'project_owner:member_added_as_owner:in_app': z.boolean(),
    'project_owner:project_trashed:email': z.boolean(),
    'project_owner:project_trashed:in_app': z.boolean(),
    'project_owner:project_restored:email': z.boolean(),
    'project_owner:project_restored:in_app': z.boolean(),
    'project_owner:project_archived:email': z.boolean(),
    'project_owner:project_archived:in_app': z.boolean(),
    'project_owner:project_unarchived:email': z.boolean(),
    'project_owner:project_unarchived:in_app': z.boolean(),
    'project_owner:project_closed:email': z.boolean(),
    'project_owner:project_closed:in_app': z.boolean(),
    'project_owner:project_reopened:email': z.boolean(),
    'project_owner:project_reopened:in_app': z.boolean(),
    'project_owner:project_chat_message_created:in_app': z.boolean(),
    'project_owner:project_chat_message_created:email': z.boolean(),
    'project_owner:task_created:email': z.boolean(),
    'project_owner:task_created:in_app': z.boolean(),
    'project_owner:task_sent:email': z.boolean(),
    'project_owner:task_sent:in_app': z.boolean(),
    'project_owner:task_sent_bulk:in_app': z.boolean(),
    'project_owner:task_submitted:in_app': z.boolean(),
    'project_owner:task_submitted:email': z.boolean(),
    'project_owner:task_declined:in_app': z.boolean(),
    'project_owner:task_declined:email': z.boolean(),
    'project_owner:task_accepted:email': z.boolean(),
    'project_owner:task_accepted:in_app': z.boolean(),
    'project_owner:task_sent_back:in_app': z.boolean(),
    'project_owner:task_sent_back:email': z.boolean(),
    'project_owner:task_cancelled:email': z.boolean(),
    'project_owner:task_cancelled:in_app': z.boolean(),
    'project_owner:task_deleted:email': z.boolean(),
    'project_owner:task_deleted:in_app': z.boolean(),
    // project_watcher notifications
    'project_watcher:member_added_as_watcher:email': z.boolean(),
    'project_watcher:member_added_as_watcher:in_app': z.boolean(),
    'project_watcher:project_trashed:email': z.boolean(),
    'project_watcher:project_trashed:in_app': z.boolean(),
    'project_watcher:project_restored:email': z.boolean(),
    'project_watcher:project_restored:in_app': z.boolean(),
    'project_watcher:project_archived:email': z.boolean(),
    'project_watcher:project_archived:in_app': z.boolean(),
    'project_watcher:project_unarchived:email': z.boolean(),
    'project_watcher:project_unarchived:in_app': z.boolean(),
    'project_watcher:project_closed:email': z.boolean(),
    'project_watcher:project_closed:in_app': z.boolean(),
    'project_watcher:project_reopened:email': z.boolean(),
    'project_watcher:project_reopened:in_app': z.boolean(),
    'project_watcher:project_chat_message_created:in_app': z.boolean(),
    'project_watcher:project_chat_message_created:email': z.boolean(),
    'project_watcher:task_created:email': z.boolean(),
    'project_watcher:task_created:in_app': z.boolean(),
    'project_watcher:task_sent:email': z.boolean(),
    'project_watcher:task_sent:in_app': z.boolean(),
    'project_watcher:task_sent_bulk:in_app': z.boolean(),
    'project_watcher:task_submitted:in_app': z.boolean(),
    'project_watcher:task_submitted:email': z.boolean(),
    'project_watcher:task_declined:in_app': z.boolean(),
    'project_watcher:task_declined:email': z.boolean(),
    'project_watcher:task_accepted:email': z.boolean(),
    'project_watcher:task_accepted:in_app': z.boolean(),
    'project_watcher:task_sent_back:in_app': z.boolean(),
    'project_watcher:task_sent_back:email': z.boolean(),
    'project_watcher:task_cancelled:email': z.boolean(),
    'project_watcher:task_cancelled:in_app': z.boolean(),
    'project_watcher:task_deleted:email': z.boolean(),
    'project_watcher:task_deleted:in_app': z.boolean(),
});
export const DEFAULT_NOTIFICATION_PREFERENCES = {
    // org maintainer notifications
    'org_maintainer:project_created:email': false,
    'org_maintainer:project_created:in_app': true,
    'org_maintainer:member_added:email': true,
    'org_maintainer:member_added:in_app': true,
    // project owner notifications
    'project_owner:member_added_as_owner:email': true,
    'project_owner:member_added_as_owner:in_app': true,
    'project_owner:project_trashed:email': false,
    'project_owner:project_trashed:in_app': true,
    'project_owner:project_restored:email': false,
    'project_owner:project_restored:in_app': true,
    'project_owner:project_archived:email': false,
    'project_owner:project_archived:in_app': true,
    'project_owner:project_unarchived:email': false,
    'project_owner:project_unarchived:in_app': true,
    'project_owner:project_closed:email': false,
    'project_owner:project_closed:in_app': true,
    'project_owner:project_reopened:email': false,
    'project_owner:project_reopened:in_app': true,
    'project_owner:project_chat_message_created:in_app': true,
    'project_owner:project_chat_message_created:email': true,
    'project_owner:task_created:email': false,
    'project_owner:task_created:in_app': true,
    'project_owner:task_sent:email': false,
    'project_owner:task_sent:in_app': true,
    'project_owner:task_sent_bulk:in_app': true,
    'project_owner:task_submitted:in_app': true,
    'project_owner:task_submitted:email': true,
    'project_owner:task_declined:in_app': true,
    'project_owner:task_declined:email': true,
    'project_owner:task_accepted:email': true,
    'project_owner:task_accepted:in_app': true,
    'project_owner:task_sent_back:in_app': true,
    'project_owner:task_sent_back:email': false,
    'project_owner:task_cancelled:email': false,
    'project_owner:task_cancelled:in_app': true,
    'project_owner:task_deleted:email': false,
    'project_owner:task_deleted:in_app': true,
    // project_watcher notifications
    'project_watcher:member_added_as_watcher:email': false,
    'project_watcher:member_added_as_watcher:in_app': true,
    'project_watcher:project_trashed:email': false,
    'project_watcher:project_trashed:in_app': false,
    'project_watcher:project_restored:email': false,
    'project_watcher:project_restored:in_app': false,
    'project_watcher:project_archived:email': false,
    'project_watcher:project_archived:in_app': false,
    'project_watcher:project_unarchived:email': false,
    'project_watcher:project_unarchived:in_app': false,
    'project_watcher:project_closed:email': false,
    'project_watcher:project_closed:in_app': false,
    'project_watcher:project_reopened:email': false,
    'project_watcher:project_reopened:in_app': false,
    'project_watcher:project_chat_message_created:in_app': true,
    'project_watcher:project_chat_message_created:email': false,
    'project_watcher:task_created:email': false,
    'project_watcher:task_created:in_app': false,
    'project_watcher:task_sent:email': false,
    'project_watcher:task_sent:in_app': false,
    'project_watcher:task_sent_bulk:in_app': false,
    'project_watcher:task_submitted:in_app': true,
    'project_watcher:task_submitted:email': false,
    'project_watcher:task_declined:in_app': true,
    'project_watcher:task_declined:email': false,
    'project_watcher:task_accepted:email': true,
    'project_watcher:task_accepted:in_app': true,
    'project_watcher:task_sent_back:in_app': false,
    'project_watcher:task_sent_back:email': false,
    'project_watcher:task_cancelled:email': false,
    'project_watcher:task_cancelled:in_app': false,
    'project_watcher:task_deleted:email': false,
    'project_watcher:task_deleted:in_app': false,
};
//# sourceMappingURL=notifications.js.map